(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvController', PvController);

    PvController.$inject = ['$state', 'Pv', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams','$scope'];

    function PvController($state, Pv, ParseLinks, AlertService, paginationConstants, pagingParams,$scope) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.getLabelClassText = getLabelClassText;       
        vm.getLabelClass = getLabelClass;


		//$scope.names = ["SNIFFER", "DEMANDA"];
		vm.names = ["SNIFFER", "DEMANDA"];

        loadAll();

        function getLabelClass (statusState) {
			if (statusState === 1) {
                return 'label-success';
            } else {
				return 'label-primary';
            }
        }

        function getLabelClassText (statusState) {
            if (statusState === 1) {
                return 'DEMANDA';
            } else {
                return 'SNIFFER';
            }
        }

        function loadAll () {
            Pv.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.pvs = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
